"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _styles = require("@material-ui/styles");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _core = require("@material-ui/core");

var _lab = require("@material-ui/lab");

var _icons = require("@material-ui/icons");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    marginBottom: {
      marginBottom: 20
    },
    formLabel: {
      fontSize: 12,
      marginTop: 3
    },
    colorPicker: {
      width: "100%",
      marginTop: ".2rem",
      marginBottom: "1rem"
    }
  };
});

var BoldLabel = _styledComponents.default.label(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: block;\n  margin: 0 0 0.28571429rem 0;\n  color: rgba(0, 0, 0, 0.87);\n  font-size: 0.92857143em;\n  font-weight: 700;\n  text-transform: none;\n"])));

var AttributesButton = function AttributesButton(_ref) {
  var objectsForm = _ref.objectsForm,
      properties = _ref.properties,
      handleItemAttribute = _ref.handleItemAttribute,
      handlePropertyChange = _ref.handlePropertyChange,
      accordionFilter = _ref.accordionFilter;
  var classes = useStyles();
  var attributes = properties.attributes;

  var _useState = (0, _react.useState)(attributes.align),
      _useState2 = _slicedToArray(_useState, 2),
      alignment = _useState2[0],
      setAlignment = _useState2[1];

  var _useState3 = (0, _react.useState)(attributes.color),
      _useState4 = _slicedToArray(_useState3, 2),
      color = _useState4[0],
      setColor = _useState4[1];

  var _useState5 = (0, _react.useState)(attributes.background),
      _useState6 = _slicedToArray(_useState5, 2),
      backgroundColor = _useState6[0],
      setBackgroundColor = _useState6[1];

  var _useState7 = (0, _react.useState)(attributes.textColor),
      _useState8 = _slicedToArray(_useState7, 2),
      textColor = _useState8[0],
      setTextColor = _useState8[1];

  var handleAlignment = function handleAlignment(e, newAlignment) {
    return setAlignment(newAlignment);
  };

  var handleColor = function handleColor(e, newColor) {
    return setColor(newColor);
  };

  var handleTextColor = function handleTextColor(e, newColor) {
    return setTextColor(newColor);
  };

  var handleBackgroundColor = function handleBackgroundColor(e, newColor) {
    return setBackgroundColor(newColor);
  };

  var handleSelectAccordion = function handleSelectAccordion(e) {
    return handlePropertyChange(properties, "childAccordion", e.target.value);
  };

  return /*#__PURE__*/React.createElement("form", null, accordionFilter(objectsForm).length > 0 && /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(_core.Tooltip, {
    title: "Define a que acordeon pertenece",
    "aria-label": "value",
    placement: "top"
  }, /*#__PURE__*/React.createElement(_core.FormControl, {
    component: "fieldset"
  }, /*#__PURE__*/React.createElement(_core.FormLabel, {
    component: "label",
    className: classes.formLabel
  }, "Definir a que acordeon pertenece"), /*#__PURE__*/React.createElement(_core.RadioGroup, {
    "aria-label": "childAccordion",
    name: "childAccordion",
    value: properties.childAccordion,
    onChange: handleSelectAccordion
  }, accordionFilter(objectsForm).filter(function (res) {
    return res.i !== "step-0";
  }).map(function (acc, key) {
    return /*#__PURE__*/React.createElement(_core.FormControlLabel, {
      key: key,
      value: acc.i,
      control: /*#__PURE__*/React.createElement(_core.Radio, {
        color: "primary"
      }),
      label: acc.label
    });
  })), /*#__PURE__*/React.createElement(_core.Button, {
    disabled: !properties.childAccordion,
    size: "small",
    onClick: function onClick(e) {
      e.preventDefault();
      handlePropertyChange(properties, "childAccordion", null);
    }
  }, "Reset accordion")))), /*#__PURE__*/React.createElement(_core.TextField, {
    label: "Etiqueta",
    value: attributes.label,
    onChange: function onChange(e) {
      handleItemAttribute(properties, "label", e.target.value);
    },
    className: classes.marginBottom
  }), /*#__PURE__*/React.createElement(BoldLabel, null, "Alineaci\xF3n"), /*#__PURE__*/React.createElement(_lab.ToggleButtonGroup, {
    value: alignment,
    exclusive: true,
    onChange: handleAlignment,
    "aria-label": "text alignment",
    size: "small",
    className: classes.marginBottom
  }, /*#__PURE__*/React.createElement(_lab.ToggleButton, {
    value: "flex-left",
    "aria-label": "left aligned",
    onClick: function onClick() {
      handleItemAttribute(properties, "align", "flex-start");
    }
  }, /*#__PURE__*/React.createElement(_icons.FormatAlignLeft, null)), /*#__PURE__*/React.createElement(_lab.ToggleButton, {
    value: "center",
    "aria-label": "centered",
    onClick: function onClick() {
      handleItemAttribute(properties, "align", "center");
    }
  }, /*#__PURE__*/React.createElement(_icons.FormatAlignCenter, null)), /*#__PURE__*/React.createElement(_lab.ToggleButton, {
    value: "flex-end",
    "aria-label": "right aligned",
    onClick: function onClick() {
      handleItemAttribute(properties, "align", "flex-end");
    }
  }, /*#__PURE__*/React.createElement(_icons.FormatAlignRight, null))), /*#__PURE__*/React.createElement(_core.InputLabel, {
    style: {
      marginBottom: 10
    }
  }, "Color de fondo"), /*#__PURE__*/React.createElement("input", {
    type: "color",
    value: backgroundColor,
    style: {
      backgroundColor: backgroundColor,
      background: backgroundColor,
      color: "red"
    },
    className: classes.colorPicker,
    onChange: function onChange(e) {
      var val = e.target.value;
      setBackgroundColor(val);
      handleItemAttribute(properties, "background", val);
    }
  }), /*#__PURE__*/React.createElement(_core.InputLabel, {
    style: {
      marginBottom: 10
    }
  }, "Color de texto"), /*#__PURE__*/React.createElement("input", {
    type: "color",
    value: textColor,
    className: classes.colorPicker,
    onChange: function onChange(e) {
      var val = e.target.value; //setColor(val);

      handleTextColor(val);
      handleItemAttribute(properties, "color", val);
    }
  }), /*#__PURE__*/React.createElement(BoldLabel, null, "Tipo"), /*#__PURE__*/React.createElement(_lab.ToggleButtonGroup, {
    value: color,
    exclusive: true,
    onChange: handleColor,
    "aria-label": "color btn",
    size: "medium",
    className: classes.marginBottom
  }, /*#__PURE__*/React.createElement(_lab.ToggleButton, {
    value: "contained",
    "aria-label": "left aligned",
    onClick: function onClick() {
      handleItemAttribute(properties, "variant", "contained");
    },
    style: {
      backgroundColor: "#3F51B5",
      color: "white"
    }
  }, "Contained"), /*#__PURE__*/React.createElement(_lab.ToggleButton, {
    value: "outlined",
    "aria-label": "centered",
    onClick: function onClick() {
      handleItemAttribute(properties, "variant", "outlined");
    },
    style: {
      backgroundColor: "transparent",
      color: "#3F51B5",
      borderColor: "#3F51B5"
    }
  }, "Outlined")), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(_core.Tooltip, {
    title: "Cambia el tama\xF1o del bot\xF3n",
    "aria-label": "allowNull",
    placement: "left-start"
  }, /*#__PURE__*/React.createElement(_core.FormControlLabel, {
    control: /*#__PURE__*/React.createElement(_core.Switch, {
      name: "allowNull",
      color: "primary",
      checked: attributes.fullWidth,
      onChange: function onChange(e, checked) {
        handleItemAttribute(properties, "fullWidth", checked);
      }
    }),
    label: "Tama\xF1o completo"
  })));
};

var _default = AttributesButton;
exports.default = _default;